import { Injectable } from "@angular/core";
import { ProjectSelectors } from "@app/project/store/selectors";
import { EffectsUtils } from "@app/root-store/effects/effect-creators";
import { ActionWord } from "@app/shared/resources/action-word";
import { checkCurrentID } from "@app/shared/resources/data-actions";
import { Actions } from "@ngrx/effects";
import { select, Store } from "@ngrx/store";
import { map } from "rxjs/operators";
import { CHRulesDbService } from "../../services/ch-rules-db.service";
import { ConditionActions } from "../actions";

@Injectable()
export class ConditionEffects extends EffectsUtils {
    constructor(actions$: Actions, private readonly ruleService: CHRulesDbService, private readonly store: Store) {
        super(actions$);
    }

    getConditions$ = this.createSwitchEffect({
        dbMethod: ({ uuid }) =>
            this.ruleService.getConditions(uuid).pipe(
                checkCurrentID(this.store.pipe(select(ProjectSelectors.getUuid)), uuid),
                map(conditions => ({ uuid, conditions }))
            ),
        actionSet: ConditionActions.loadSet,
    });

    getSceneCommandsFailure$ = this.createFailureEffect(
        ConditionActions.loadSet.failure,
        ActionWord.retrieved,
        null,
        "Error getting actions"
    );
}
